import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {Messages, showMessage} from "@app/constants/Messages";
import JobSendRequestNoteContent from "@pages/candidate/detail/JobSendRequestNoteContent";

const JobSendRequestNotes = (props) => {
    const [notes, setNotes] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateId} = props

    const updateJobSendRequestNotes = () => {
        CandidateService.updateJobSendRequestNotes({candidate_id: candidateId, notes: notes}).then((res) => {
            console.log(JSON.stringify(res))
            showMessage(Messages.saveInfoSuccess, false, true)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const fetchJobSendRequestNotes = (canId) => {
        if (!canId) {
            return;
        }
        CandidateService.getJobSendRequestInputNotes(canId).then((res) => {
            setNotes([...res.content])
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        fetchJobSendRequestNotes(candidateId)
    }, [candidateId])

    const onAddItem = () => {
        notes.push({
            note: '',
            created_date_time: '',
            created_user: userLoginInfo.id
        });

        setNotes([...notes]);
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Note Yêu cầu gửi job</h3>
                    <div className='card-tools'>
                        <button type={'button'} className={'btn btn-success mr-2'}
                                onClick={() => onAddItem()}>Add</button>
                        <button type='button'
                                className='btn btn-primary'
                                onClick={() => {
                                    updateJobSendRequestNotes();
                                }}
                        >
                            Save
                        </button>

                    </div>
                </div>
                <div className='card-body'>
                    <div className='input-group'>
                        <div style={{width: '100%'}}>
                            <JobSendRequestNoteContent notes={notes} onChange={(contents) => setNotes([...contents])}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default JobSendRequestNotes;
